//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

(function () {
  /**
   * Unison select dropdown used as a search filter control.
   *
   * @param {Object[]} options - Array of objects for what options should be available from this dropdown
   * @param {string} options[].value - value which the search-filter-dropdown component will output when this option is selected.
   *                                   Use the value 'noVal' to clear the filter.
   * @param {string} options[].label - label used for this option in the dropdown
   * @param {string} dropdownLabel - optional label to display in the dropdown when no value is selected.
   * @param {string} widthOverride - Optional width style to override the dropdown width. By default, the width of the dropdown is
   *                                 determined by the size of its currently selected cu-select-item, so by setting this attribute
   *                                 you can force the dropdown to be a certain size.
   */
  angular.module('curalate').component('searchFilterCuDropdown', {
    bindings: {
      options: '<',
      dropdownLabel: '<',
      widthOverride: '@?',
    },
    require: {
      searchFilter: '^searchFilter',
    },
    template: require('@legacy-components/filters/search-filter-cu-dropdown.html'),
    controller: [
      '$state',
      function ($state) {
        const self = this;

        self.onChange = function (newValue) {
          const option = _(self.options).find((opt) => opt.value === newValue);

          if (
            option === null ||
            option === undefined ||
            option.value === 'noVal'
          ) {
            self.searchFilter.clearValues();
          } else {
            self.searchFilter.setValue(newValue);
          }
        };

        this.$onInit = function () {
          _(self.options).each((option) => {
            if (option.value !== null && option.value !== 'noVal') {
              self.searchFilter.registerFilterOptionAlias(
                option.value,
                option.label,
              );
            }
          });

          self.lockedKey = self.searchFilter.isKeyLocked();

          self.searchFilter.getFilterValueStream().subscribe((newState) => {
            if (newState && newState[0]) {
              if (self.value !== newState[0]) {
                self.value = newState[0];
              }
            }
          });

          const currentSearchFilterValue = self.searchFilter.getValue()[0];

          const initialValue =
            self.options.find(
              ({ value }) => value === currentSearchFilterValue,
            ) || self.options[0];

          self.searchFilter.setValue(initialValue.value);

          self.value = initialValue.value;
          self.dropdownLabel = self.dropdownLabel || initialValue.label;
        };
      },
    ],
  });
})();
